export enum PromoKeys {
  VOA_FANNIE_FREDDIE_POPUP = 'voa-fannie-freddie-popup',
  VOA_FANNIE_FREDDIE_HEADER = 'voa-fannie-freddie-header',
  MOBILE_DESKTOP_BANNER = 'mobile-desktop-banner',
}

export type PromoConfig = {
  id: PromoKeys;
  enabled?: boolean;
  interval?: number;
  href?: string;
};
